import transform from '../../utils/ResponseTransformator'
import mapResponseToTemplates from './mappers/mapResponseToTemplates'
import { IData } from './fetchTemplates'

export default function(api: GlobalFetch) {
  return async function(template) {
    const requestBody = template
    // requestBody.mode = 0
    const response = await api.fetch(`/api/v2/template/index`, {
      body: JSON.stringify(requestBody),
      method: 'POST',
    })
    let text: string = await response.text()
    text = transform(text)
    const responseBody: IData = JSON.parse(text)

    return mapResponseToTemplates(responseBody)
  }
}
